"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casalmaggiore": {
    "9cc34d2e": [{
      "hkey": "eb21bcff",
      "slug": "fossacaprara",
      "name": "Fossacaprara",
      "primary": true,
      "skipSearch": false
    }],
    "fossa-caprara": [{
      "hkey": "eb21bcff",
      "slug": "fossacaprara",
      "name": "Fossacaprara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ccda4fec": [{
      "hkey": "4c83dca8",
      "slug": "casalmaggiore",
      "name": "Casalmaggiore",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "4c83dca8",
      "slug": "casalmaggiore",
      "name": "Casalmaggiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc1827d8": [{
      "hkey": "04cc71d3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-vicobellignano": [{
      "hkey": "04cc71d3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;